import React from "react"

import BaseSvgIcon from "../Base"

const AccessTime = (props) => {
  return (
    <BaseSvgIcon {...props} viewBox="0 0 20 20">
      <path
        fill="#402aff"
        d="M9.99 0C4.47 0 0 4.48 0 10s4.47 10 9.99 10C15.52 20 20 15.52 20 10S15.52 0 9.99 0m3.3 14.71L9 10.41V5h2v4.59l3.71 3.71z"
      />
    </BaseSvgIcon>
  )
}

export default AccessTime
